<template>
  <div>
    <vote-list-with-candidates
      v-if="hasCandidates"
      :has-candidates="hasCandidates"
      :votes="votes"
      :nominees="nominees"
      :question-id="questionId"
      :votes-left="votesLeft"
      :custom-options="customOptions"
      :has-election-ranking="hasElectionRanking"
      :type="type"
    />

    <vote-list-no-candidates
      v-else
      :votes="votes"
      :question-id="questionId"
      :num-positions="numPositions"
    />
  </div>
</template>

<script>
import VoteListWithCandidates from './ElectionsVoteListWithCandidates.vue';
import VoteListNoCandidates from './ElectionsVoteListNoCandidates.vue';

export default {
  props: {
    hasCandidates: {
      type: Boolean,
      required: true
    },
    votes: {
      type: Array
    },
    nominees: {
      type: Array
    },
    questionId: {
      type: [String, Number],
      required: true
    },
    votesLeft: {
      type: Number,
      required: true
    },
    customOptions: {
      type: Object
    },
    numPositions: {
      type: [Number, String],
      required: true
    },
    hasElectionRanking: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    }
  },
  components: {
    VoteListWithCandidates,
    VoteListNoCandidates
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Questions/Elections/ElectionsVoteList.vue